<template>
	<!-- 
		Lock-Button 
		Versin 1.1

		Las propiedades ahora tienen formato VueJS

		Corrige el error de propagación cuando un botón se ha defindo desde $parent como disabled.
		@author Daniel Lepe
		@date 12/Oct/2021
	 -->
	<div class="button-holder" :class="alt">
		<button @click="triggerCallback($event)" class="lock-button shadow-3d-small" :class="currentClass" :disabled="isProcessing || disabled">
			<slot name="default" v-if="!isProcessing">{{currentLabel}}</slot>
			<slot name="busy-label" v-else>{{busyLabel}}</slot>
		</button>
	</div>

</template>

<script>
	export default {
		// props: ['isProcessing', 'callback', 'label', 'busyLabel', 'alt', 'danger', 'disabled'],
		props: {
			isProcessing: {
				type: [String, Number, Boolean],
				default: false
			},
			disabled: {
				type: [String, Number, Boolean],
				default: false
			},
			label: {
				type: [String],
				default: 'Aplicar'
			},
			busyLabel: {
				type: [String],
				default: 'Procesando...'
			},
			alt: {
				type: [String],
				default: ''
			},
			callback: {
				type: Function
			}
		},
		computed: {
			currentClass() {
				return ((!this.isProcessing) ? "main-btn bg-primary" : "main-btn bg-disabled") + ' ' + ((this.disabled) ? "disabled" : "")
			},
			currentLabel() {
				return (!this.isProcessing) ? this.label : this.busyLabel
			}
		},
		methods: {
			triggerCallback(event) {
				if((!this.disabled || this.disabled == 'false') && !this.isProcessing){
					if (typeof this.callback == 'function') {
						this.callback(event)
					} else if (!this.isProcessing){
						this.$emit('click', event)
					}
				} else {
					event.stopPropagation()
				}
			}
		}
	}
</script>

<style lang="less">
	.button-holder {
		
		padding: 1em 0.75em;
		display: block;
		margin: 1em 0;
		font-size: calc(var(--ui-font-size) * .7);

		& + .button-holder {
			margin-top: 1em;
		}

		button {
			
			margin: 0 auto;
			display: block;
			width: 100%;
			max-width: var(--ui-max-width);
			// box-shadow: var(--ui-box-shadow);
			padding: var(--ui-padding);
			text-transform: uppercase;
			font-weight: bold;
			color: var(--white);
			font-size: calc(var(--ui-font-size) * .7);
			background-color: var(--secondary);
			border: none;
			// border-radius: var(--ui-border-radius);
			border-radius: 0.5em;
			cursor: pointer;
			// box-shadow: var(--ui-box-shadow);

			&:disabled {
				opacity: 0.5;
			}

			&:enabled:hover, &:enabled:active {
				background-color: var(--secondary-dark);
				cursor: pointer;
			}

			@media screen and (min-width: 375px){
				font-size: calc(var(--ui-font-size) * .9);
			}
			
		}

		&.secondary {
			button {
				background-color: var(--secondary);
				color: var(--white);
				&:hover:enabled, &:active:enabled {
					background-color: var(--secondary-dark);
				}
			}
		}

		&.danger {
			button {
				background-color: var(--danger);
				color: var(--white);
				&:hover:enabled, &:active:enabled {
					background-color: var(--danger-dark);
				}
			}
		}
		
		&.dimmed, &.subtle {
			button {
				background-color: var(--dimmed);
				color: var(--dark);
				&:hover:enabled, &:active:enabled {
					background-color: var(--dimmed-dark);
				}
			}
		}

		&.dark {
			button {
				background-color: var(--black-translucent);
				color: var(--white);
				&:hover:enabled, &:active:enabled {
					background-color: var(--dark);
				}
			}
		}

		&, &.success {
			button {
				background-color: var(--primary);
				color: var(--white);
				&:hover:not(.disabled), &:active:not(.disabled)  {
					background-color: var(--primary-dark);
				}
			}
		}

	}
</style>